<section class="legal-section modern-section section-first" #legalRoot>
  <div class="container px-5">
    <div class="row justify-content-center mb-5">
      <div class="col-lg-8 text-center">
        <div class="section-head reveal-on-scroll" data-reveal="section-head" data-reveal-trigger="immediate">
          <h1 class="modern-section-title">Política de <span class="highlight-green">Privacidad</span></h1>
          <div class="section-underline"></div>
          <p class="modern-section-desc mb-0">Última actualización: 2026</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="glass-card text-light lh-lg reveal-on-scroll" data-reveal="card" style="--reveal-order: 1">
          <div class="legal-notice">
            <strong>Identidad del responsable.</strong> El sitio web grupodingo.com.mx y los servicios asociados a la marca
            <strong>Grupo DINGO</strong> son operados bajo la marca comercial <strong>DINGO</strong>, la cual es propiedad de
            <strong>Pleiades Investment Solutions</strong>. La entidad legal responsable del tratamiento de datos personales
            es Pleiades Investment Solutions. Cualquier referencia a "Grupo DINGO", "DINGO" o "nosotros" en esta política
            se refiere a la operación de dicha marca por parte de Pleiades Investment Solutions.
          </div>

          <h2 class="text-primary-green fs-5 fw-bold mb-2">1. Recopilación de información</h2>
          <p class="mb-3">
            Recopilamos información que nos proporcionas al contactarnos (nombre, correo electrónico, teléfono, empresa y
            mensaje), datos de navegación y uso del sitio (dirección IP, tipo de dispositivo, páginas visitadas) y cookies
            necesarias para el funcionamiento y la mejora del sitio.
          </p>

          <h2 class="text-primary-green fs-5 fw-bold mt-4 mb-2">2. Uso de la información</h2>
          <p class="mb-3">
            Utilizamos tus datos para responder a tus consultas, enviar información sobre nuestros servicios, mejorar
            nuestra web y cumplir con obligaciones legales. No vendemos ni compartimos tus datos personales con terceros
            para fines de marketing no autorizado.
          </p>

          <h2 class="text-primary-green fs-5 fw-bold mt-4 mb-2">3. Base legal y finalidad</h2>
          <p class="mb-3">
            El tratamiento se basa en tu consentimiento (formularios de contacto y comunicaciones), en la ejecución de
            relaciones precontractuales o contractuales y en el interés legítimo de Pleiades Investment Solutions para
            operar la marca DINGO y ofrecer sus servicios.
          </p>

          <h2 class="text-primary-green fs-5 fw-bold mt-4 mb-2">4. Conservación y seguridad</h2>
          <p class="mb-3">
            Conservamos tus datos el tiempo necesario para las finalidades indicadas o el exigido por la ley. Implementamos
            medidas técnicas y organizativas para proteger tu información contra accesos no autorizados o pérdida.
          </p>

          <h2 class="text-primary-green fs-5 fw-bold mt-4 mb-2">5. Tus derechos</h2>
          <p class="mb-3">
            Puedes ejercer derechos de acceso, rectificación, cancelación, oposición, limitación del tratamiento y
            portabilidad, así como revocar tu consentimiento, contactando a: <a href="mailto:contacto&#64;grupodingo.com.mx" class="text-primary-green text-decoration-underline">contacto&#64;grupodingo.com.mx</a>. Tienes derecho a presentar
            una reclamación ante la autoridad de protección de datos competente.
          </p>

          <h2 class="text-primary-green fs-5 fw-bold mt-4 mb-2">6. Cambios</h2>
          <p class="mb-3">
            Nos reservamos el derecho de actualizar esta política. Los cambios relevantes se publicarán en esta página con
            la nueva fecha de actualización.
          </p>

          <a routerLink="/inicio" class="d-inline-flex align-items-center gap-2 text-primary-green fw-semibold text-decoration-none mt-4">
            <i class="bi bi-arrow-left"></i> Volver al inicio
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
